import { useState } from "react";
import PageManager from "./seo/PageManager";
import { Overview, GlobalSettings, RobotsEditor, SitemapPanel, SearchConsole } from "./seo/Panels";

const NAV = ["Overview", "Global Settings", "Page SEO Manager", "Books SEO", "Authors SEO", "Robots.txt Editor", "XML Sitemap", "Schema Manager", "SEO Health", "Search Console"];

export default function SeoCMS() {
  const [tab, setTab] = useState("Overview");
  return (
    <div className="grid lg:grid-cols-[210px_1fr] gap-6" data-testid="seo-dashboard">
      <nav className="flex lg:flex-col gap-1 overflow-x-auto">
        {NAV.map((n) => (
          <button key={n} onClick={() => setTab(n)} data-testid={`seo-nav-${n.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={`text-left whitespace-nowrap px-4 py-2 rounded-xl text-sm transition-colors ${tab === n ? "bg-primary text-primary-foreground" : "hover:bg-secondary"}`}>{n}</button>
        ))}
      </nav>
      <div className="min-w-0">
        {tab === "Overview" && <Overview go={setTab} />}
        {tab === "Global Settings" && <GlobalSettings />}
        {tab === "Page SEO Manager" && <PageManager />}
        {tab === "Books SEO" && <PageManager key="b" presetType="book" />}
        {tab === "Authors SEO" && <PageManager key="a" presetType="author" />}
        {tab === "Robots.txt Editor" && <RobotsEditor />}
        {tab === "XML Sitemap" && <SitemapPanel />}
        {tab === "Schema Manager" && <GlobalSettings schemaOnly />}
        {tab === "SEO Health" && <PageManager key="h" presetStatus="issues" />}
        {tab === "Search Console" && <SearchConsole />}
      </div>
    </div>
  );
}
